import axios from 'axios';
import {
    metaRequest,
    metaSuccess,
    metaFail,
    metaAllRequest,
    metaAllSuccess,
    metaAllFail,
    newMetaFail,
    newMetaSuccess,
    newMetaRequest,
    updateMetaFail,
    updateMetaRequest,
    updateMetaSuccess,
    deleteMetaRequest,
    deleteMetaSuccess,
    deleteMetaFail
} from '../slices/metaSlice';

export const saveMeta = ({ metaData, id }) => async (dispatch) => {
    try {

        const config = {
            headers: { "Content-Type": "application/json" },
        };

        dispatch(newMetaRequest())

        const { data } = id
            ? await axios.put(`${process.env.REACT_APP_API_URL}/api/v1/admin/meta/${id}`, metaData, config)
            : await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/admin/meta`, metaData, config);

        dispatch(newMetaSuccess(data?.meta))
    } catch (error) {
        const message =
            error.response?.data?.message || "Something went wrong. Please try again.";
        dispatch(newMetaFail(message));
    }

}

//user
export const fetchMeta = (slug, category, subCategory, brand) => async (dispatch) => {

    try {
        dispatch(metaRequest())
        const params = new URLSearchParams();

        if (slug) params.append("slug", slug);
        if (category) params.append("category", category);
        if (subCategory) params.append("subCategory", subCategory);
        if (brand) params.append("brand", brand);
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/meta?${params.toString()}`);

        dispatch(metaSuccess(data?.meta))
    } catch (error) {
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(metaFail(message))
    }

}

export const fetchAdminMeta = (id) => async (dispatch) => {

    try {
        dispatch(metaRequest())
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/admin/meta/${id}`);
        dispatch(metaSuccess(data?.meta))
    } catch (error) {
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(metaFail(message))
    }

}

export const listAllMeta = () => async (dispatch) => {

    try {
        dispatch(metaAllRequest())
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/admin/meta`);
        dispatch(metaAllSuccess(data?.metas))
    } catch (error) {
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(metaAllFail(message))
    }

}

export const toggleMetaStatus = (id) => async (dispatch) => {

    try {
        dispatch(updateMetaRequest())
        const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/api/v1/admin/meta-toggle/${id}`);
        dispatch(updateMetaSuccess(data))
    } catch (error) {
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(updateMetaFail(message))
    }

}

export const deleteMeta = (id) => async (dispatch) => {

    try {
        dispatch(deleteMetaRequest())
        const { data } = await axios.delete(`${process.env.REACT_APP_API_URL}/api/v1/admin/meta/${id}`);
        dispatch(deleteMetaSuccess(data))
    } catch (error) {
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(deleteMetaFail(message))
    }

}